<h1 mat-dialog-title>Betriebe {{ user?.vorname }}&nbsp;{{ user?.nachname }} zuweisen</h1>
<div mat-dialog-content>
    <p *ngIf="isLoading">Betriebe werden geladen …</p>
    <ng-container *ngIf="!isLoading">
        <p *ngIf="!betriebe.length">Keine Betriebe gefunden.</p>
        <div *ngFor="let b of betriebe" class="betrieb-row">
            <div class="one-row">
                <mat-checkbox
                    class="betrieb-row__checkbox"
                    [checked]="isAssigned(b)"
                    [disabled]="pendingKundeId != null"
                    (change)="betriebChanged($event, b)"
                ></mat-checkbox>
                <mat-icon>business</mat-icon>
                <span class="betrieb-row__name"
                    ><strong>{{ b.bezeichnung_final || b.bezeichnung }}</strong>
                    <span *ngIf="isFreigegeben(b)" class="betrieb-row__badge">Freigabe</span></span
                >
                <span class="spacer"></span>
            </div>
            <p *ngIf="b.zusatz_final || b.zusatz" class="betrieb-row__meta">{{ b.zusatz_final || b.zusatz }}</p>
            <p *ngIf="b.vvvo" class="betrieb-row__meta">{{ b.vvvo }}</p>
        </div>
    </ng-container>
</div>
<div mat-dialog-actions>
    <span class="spacer"></span>
    <button mat-button (click)="dialogRef.close()">Schlie&szlig;en</button>
</div>
